import { API, unwrapData } from '../axios-instance'

export type ChecklistItem = {
  tenantId: string
  itemAlias: string
  completed: boolean
  createdAt: string
  updatedAt: string
  __entity_type__: 'ChecklistItem'
}

export type DismissedItem = {
  tenantId: string
  memberId: string
  itemAlias: string
  dismissedAt: string | null
  __entity_type__: 'DismissedItem'
}

export type UpdateChecklistItemParams = {
  itemAlias: string
  completed: boolean
}

export type UpdateDismissedItemParams = {
  itemAlias: string
  dismissed: boolean
}

export const listChecklistItems = async (itemAliasIn?: string[]) => {
  return await API.get<ChecklistItem[]>('/onboarding/checklistItems', {
    params: {
      itemAliasIn,
    },
  }).then(unwrapData)
}

export const listDismissedItems = async (itemAliasIn?: string[]) => {
  return await API.get<DismissedItem[]>('/onboarding/dismissedItems', {
    params: {
      itemAliasIn,
    },
  }).then(unwrapData)
}

export const updateChecklistItem = async (params: UpdateChecklistItemParams) => {
  return await API.put<boolean>('/onboarding/checklistItems', params).then(unwrapData)
}

export const updateDismissedItem = async (params: UpdateDismissedItemParams) => {
  return await API.put<boolean>('/onboarding/dismissedItems', params).then(unwrapData)
}
